import React from "react";
import { withPrefix } from "gatsby";

import useBrowserMode from "../../../shared/hooks/useBrowserMode";

import "./breadcrumb.scss";

const Breadcrumb = (props: BreadcrumbInterface) => {
  const { content } = props;
  const { isBrowser, window } = useBrowserMode();

  const getPathName = (index: number): string => {
    if (isBrowser) {
      if (index === 0) {
        return withPrefix("/");
      } else {
        const auxIndex = window.location.pathname.indexOf("/bibliotecas") !== -1 ?
          index + 1 : index;
        const paths = window.location.pathname.split("/");
        return paths[auxIndex] ? getFinalRoot(auxIndex, paths) : "#"; //`/${paths[index]}/` : '#';
      }
    }
    return "";
  };

  const getFinalRoot = (n: number, paths: string[]) => {
    let pathFinal = "/";
    for (let i = 0; i < n; i++) {
      pathFinal += paths[i + 1] + "/";
    }
    return pathFinal;
  };

  const breadcrumbs = (crumbs: string) =>
    crumbs.split('/').map((value, index) => {
      return (
        <li key={`breadcrumb-${index}`} itemProp="url" className={`crumb url-${index}`}>
          <a title={value} href={getPathName(index)}>
            <span itemProp="title"> {value} </span>
          </a>
        </li>
      );
    });

  return (
    <nav itemType="https://schema.org/Breadcrumb" className="miga-de-pan">
      <ul className="a-breadcrumb">{isBrowser && breadcrumbs(content)}</ul>
    </nav>
  );
};

interface BreadcrumbInterface {
  content: any;
}

export default Breadcrumb;
